// src/utils/content.js
import BASE_URL from "../config";

export const decodeHtml = (text) => {
  if (!text) return "";
  let out = text;
  const ta = document.createElement("textarea");
  let i = 0;
  do {
    ta.innerHTML = out;
    out = ta.value;
    i++;
  } while (out.includes("&") && i < 10);
  return out;
};

export const pickLang = (item, field, lang) => {
  if (!item) return "";
  if (lang === "ar") return item[`${field}_ar`] || item[field] || "";
  if (lang === "en") return item[`${field}_en`] || item[field] || "";
  return item[field] || "";
};

export const getTitle = (item, lang, max = 80) => {
  const raw = pickLang(item, "name", lang);
  const decoded = decodeHtml(raw);
  if (!decoded) return "";
  return decoded.length > max ? decoded.slice(0, max) + "…" : decoded;
};

export const getImage = (item, lang) => {
  const url = pickLang(item, "image", lang);
  return url ? `${BASE_URL}${url}` : null;
};

export const getDescriptionHtml = (item, lang) => {
  return decodeHtml(pickLang(item, "description", lang));
};

export const getExcerpt = (item, lang, words = 24) => {
  const html = pickLang(item, "description", lang);
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  const text = div.innerText || div.textContent || "";
  const cut = text.split(/\s+/).slice(0, words).join(" ");
  return cut + (text.split(/\s+/).length > words ? "…" : "");
};

export const formatDate = (dateString, lang, t) => {
  if (!dateString) return t ? t("common.unknown_date") : "";
  const date = new Date(dateString);
  if (isNaN(date)) return t ? t("common.invalid_date") : "";
  const locale =
    { en: "en-US", ar: "ar-DZ", fr: "fr-FR" }[lang] || "fr-FR";
  return date.toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

// Build a localized internal path: '/' for fr, '/{lang}/...' otherwise
export const localePath = (lang, path = "") => {
  const clean = path.startsWith("/") ? path.slice(1) : path;
  if (lang === "fr") return clean ? `/${clean}` : "/";
  return clean ? `/${lang}/${clean}` : `/${lang}`;
};
